/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description statisticTopUsingGet参数
 * @property `[endTime]` endTime
 * @property `[startTime]` startTime
 */
export interface ParamsstatisticTopUsingGet {
  // queryParams
  /**
   * endTime
   */
  endTime?: string;
  /**
   * startTime
   */
  startTime?: string;
}
/**
 * @description statisticUvDistributionFileUsingGet参数
 * @property `[endTime]` endTime
 * @property `[startTime]` startTime
 */
export interface ParamsstatisticUvDistributionFileUsingGet {
  // queryParams
  /**
   * endTime
   */
  endTime?: string;
  /**
   * startTime
   */
  startTime?: string;
}
/**
 * @description statisticUvStatisticStringUsingGet参数
 * @property `[endTime]` endTime
 * @property `[startTime]` startTime
 */
export interface ParamsstatisticUvStatisticStringUsingGet {
  // queryParams
  /**
   * endTime
   */
  endTime?: string;
  /**
   * startTime
   */
  startTime?: string;
}
export class StatisticApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary topInfo
   * @param params ParamsstatisticTopUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultMonthTopInfo
   */
  public statisticTopUsingGet = (
    params: ParamsstatisticTopUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultMonthTopInfo> => {
    const path = '/api/statistic/top';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('endTime' in params) p.query.endTime = params.endTime;
    if ('startTime' in params) p.query.startTime = params.startTime;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary userDistribution
   
   
   * @param opt ajax config
   * @returns {}
   */
  public statisticUpdateAgentUsingGet = (opt?: ExtraFetchParams): AjaxPromise<{}> => {
    const path = '/api/statistic/update/agent';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary userDistribution
   * @param params ParamsstatisticUvDistributionFileUsingGet
   
   * @param opt ajax config
   * @returns {}
   */
  public statisticUvDistributionFileUsingGet = (
    params: ParamsstatisticUvDistributionFileUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<{}> => {
    const path = '/api/statistic/uv/distribution/file';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('endTime' in params) p.query.endTime = params.endTime;
    if ('startTime' in params) p.query.startTime = params.startTime;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary userStatistic
   * @param params ParamsstatisticUvStatisticStringUsingGet
   
   * @param opt ajax config
   * @returns string
   */
  public statisticUvStatisticStringUsingGet = (
    params: ParamsstatisticUvStatisticStringUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<string> => {
    const path = '/api/statistic/uv/statistic/string';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('endTime' in params) p.query.endTime = params.endTime;
    if ('startTime' in params) p.query.startTime = params.startTime;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary weekStatistic
   
   
   * @param opt ajax config
   * @returns string
   */
  public statisticWeekStatisticInitUsingGet = (opt?: ExtraFetchParams): AjaxPromise<string> => {
    const path = '/api/statistic/week/statistic/init';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new StatisticApi();
